import { ActivityScene, RouteRecordRawMeta } from "@/common/util/types";
import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router';

import { t } from '@/i18n';
import feedback_selected from '@/assets/feedback_selected.png';
import feedback from '@/assets/feedback.png';
import home from '@/assets/home.png';
import home_checked from '@/assets/home_checked.png';
import problem_selected from '@/assets/problem_selected.png';
import problem from '@/assets/problem.png';

import IndexView from "@/views/IndexView.vue";
import FeedbackView from "@/views/FeedbackView.vue";
import SubmitView from '@/views/SubmitView.vue';
import QaView from "@/views/QaView.vue";
import QaInfoView from '@/views/QaInfoView.vue';
import SubmitSuccessView from '@/views/SubmitSuccessView.vue';
import FeedbackInfoView from '@/views/FeedbackInfoView.vue';
import FeedbackInfoSuccessView from '@/views/FeedbackInfoSuccessView.vue';
import SubmitModal from '@/views/SubmitModal.vue';


import FeedbackInfoFailView from '@/views/FeedbackInfoFailView.vue';
import { createTabView } from '@/common/components/createTabView';

/**
 * 为所有组件指定场景
 * @param routes
 * @returns
 */
function setupPages(routes: Array<RouteRecordRawMeta>) {
  routes.forEach(route => {
    (route.component as any).scene = route.meta.scene;
    (route.component as any).replaceUrl = route.meta.replaceUrl;
    if (route.children) {
      setupPages(route.children);
    }
  });
  return routes;
}

/**
 * 以下为自己定义的路由
 * demoRoutes添加后请将demo推送到模版 aiyou-cli --push
 */
const getAppRoutes = (): Array<RouteRecordRawMeta> => ([
  {
    path: '/',
    name: 'home',
    component: createTabView([
      {
        path: '/index',
        title: t('homePage'),
        icon: home,
        selectedIcon: home_checked,
      },
      {
        path: '/qa',
        title: t('FrequentlyAskedQuestions'),
        icon: problem,
        selectedIcon: problem_selected,
      },
      {
        path: '/feedback',
        title: t('myFeedback'),
        icon: feedback,
        selectedIcon: feedback_selected,
      },
    ]),
    meta: {
      title: t('homePage'),
      scene: ActivityScene.Activity,
      isHomeRoute: true,
      pageName: '',
    },
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: IndexView,
        meta: {
          title: t('homePage'),
          scene: ActivityScene.Activity,
          isHomeRoute: true,
          pageName: '',
        },
      },
      {
        path: 'qa',
        name: 'qa',
        component: QaView,
        meta: {
          title: t('FrequentlyAskedQuestions'),
          scene: ActivityScene.Activity,
          isHomeRoute: true,
          pageName: '',
        },
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: FeedbackView,
        meta: {
          title: t('myFeedback'),
          scene: ActivityScene.Activity,
          isHomeRoute: true,
          pageName: '',
        },
      },
    ],
  },
  {
    path: '/submit',
    name: 'submit',
    component: SubmitView,
    meta: {
      title: '提交反馈',
      scene: ActivityScene.Activity,
      isHomeRoute: false,
      pageName: '',
    },
    children: [
      {
        path: 'success',
        name: 'submit/success',
        component: SubmitSuccessView,
        meta: {
          title: '提交成功',
          scene: ActivityScene.ModalCenterActivity,
          isHomeRoute: false,
          pageName: '',
        },
      },
    ],
  },
  {
    path: '/qa/:id',
    name: 'qa/info',
    component: QaInfoView,
    meta: {
      title: '常见问题',
      scene: ActivityScene.Activity,
      isHomeRoute: false,
      pageName: '',
    },
  },
  {
    path: '/feedback/:id',
    name: 'feedback/info',
    component: FeedbackInfoView,
    meta: {
      title: '我的反馈',
      scene: ActivityScene.Activity,
      isHomeRoute: false,
      pageName: '',
    },
    children: [
      {
        path: 'success',
        name: 'feedback/info/success',
        component: FeedbackInfoSuccessView,
        meta: {
          title: '已解决',
          scene: ActivityScene.SheetActivity,
          isHomeRoute: false,
          pageName: '',
        },
      },
      {
        path: 'fail',
        name: 'feedback/info/fail',
        component: FeedbackInfoFailView,
        meta: {
          title: '未解决',
          scene: ActivityScene.SheetActivity,
          isHomeRoute: false,
          pageName: '',
        },
      },
      {
        path: 'submitquestion',
        name: 'feedback/info/submitquestion',
        component: SubmitModal,
        meta: {
          title: '追加回复',
          scene: ActivityScene.SheetActivity,
          isHomeRoute: false,
          pageName: '',
        },
      },
      {
        path: 'successsubimit',
        name: 'feedback/info/successsubimit',
        component: SubmitSuccessView,
        meta: {
          title: '提交成功',
          scene: ActivityScene.ModalCenterActivity,
          isHomeRoute: false,
          pageName: '',
        },
      },
    ],
  },
]);

/**
 * @demoRoutes 只提供演示使用,请第一时间删除
 */
export const createAppRouter = () => {
  const routes: Array<RouteRecordRawMeta> = setupPages(getAppRoutes());
  return createRouter({
    history: createWebHistory(window.appId),
    // history: isChromeBrowser && process.env.NODE_ENV === 'development' ? createWebHistory(window.appId) : createMemoryHistory(window.appId),
    routes,
  });
};

// HMR 兼容：历史版本会在 hot.ts 中订阅该方法
export const updatedRouteSetup = () => {
  // 路由现在通过 createAppRouter() 动态创建；
  // HMR 时无需原地更新 routes。
};
